<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col
        v-if="bannerImage"
        cols="12"
        :style="styles.banner"
      >
        <v-parallax
          :src="bannerImage"
          style="z-index: 0"
          class="px-0 mx-n3"
        >
          <div class="banner-bg fill-height" />
        </v-parallax>
      </v-col>
      <v-container
        class="py-4"
        :style="styles.container"
      >
        <v-row>
          <v-col
            cols="12"
            xl="8"
            offset-xl="2"
          >
            <v-row>
              <v-col
                v-if="crumbs.length"
                class="pb-2 px-0"
                cols="12"
              >
                <v-breadcrumbs
                  :items="crumbs"
                  :class="classes.breadcrumbs"
                >
                  <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                  </template>
                </v-breadcrumbs>
              </v-col>
              <v-col
                v-if="title || intro"
                cols="12"
              >
                <p
                  :class="classes.title"
                  v-text="title"
                />
              </v-col>
            </v-row>
            <v-row
              :class="classes.body"
            >
              <v-col
                v-if="intro"
                class="subheading text-justify"
                cols="12"
                v-html="intro"
              />
              <v-col cols="12">
                <slot />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props:{
    title: {
      type: String,
      default: ''
    },
    intro: {
      type: String,
      default: ''
    },
    primary: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    bannerImage: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      let title = this.primary && this.$vuetify.breakpoint.smAndUp ? 'display-2 ' : 'display-1 '
      title += this.bannerImage
        ? 'white--text text-shadow pt-4'
        : 'primary--text text--darken-1 font-weight-light'
      let body = {
        'grey lighten-5': !!this.bannerImage
      }
      let breadcrumbs = this.bannerImage
        ? 'breadcrumbs-bg'
        : 'grey lighten-4'
      return { title, body, breadcrumbs }
    },
    styles() {
      const style = {
        container: {},
        main: {},
        banner: {}
      }
      if (this.bannerImage) {
        style.container.marginTop = '-475px'
        style.container.zIndex = 1
        style.banner.marginTop = '-12px'
      }
      return style
    },
    crumbs() {
      return this.breadcrumbs.length > 0
        ? [
            {
              text: this.$t('nav.home'),
              to: this.localePath('index'),
              disabled: false
            },
            ...this.breadcrumbs
          ].map( crumb => ({
            ...crumb,
            nuxt: true,
            exact: true
          }))
        : []
    }
  }
}
</script>

<style lang="stylus" scoped>
  .disabled
    color: grey
    pointer-events: none
  .breadcrumbs-bg
    background-color: rgba(220, 220, 220, .75)
  .banner-bg
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5) 40%, transparent 75%)
    margin: 0 -1rem
</style>